import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const Star: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 24, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 24 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M19.4081 6.49916L15.4458 5.9234L13.6738 2.33302C12.9896 0.946552 11.0105 0.946036 10.3261 2.33297L8.55404 5.9234L4.59174 6.49916C3.06174 6.72144 2.44979 8.60342 3.55726 9.68305L6.42441 12.4778L5.74759 16.424C5.48621 17.9477 7.0868 19.1114 8.45598 18.3918L11.9999 16.5286L15.5439 18.3918C16.9147 19.1124 18.513 17.9443 18.2522 16.424L17.5754 12.4778L20.4426 9.68305C21.5496 8.6038 20.9387 6.72158 19.4081 6.49916Z"
        fill="currentColor"
      />
      <path
        d="M6.31559 1.69358L5.35882 0.376768C5.09909 0.0193937 4.59879 -0.0598717 4.24142 0.199862C3.88399 0.459549 3.80478 0.959845 4.06446 1.31727L5.02123 2.63407C5.2811 2.99164 5.78145 3.07062 6.13863 2.81098C6.49606 2.55134 6.57527 2.051 6.31559 1.69358Z"
        fill="currentColor"
      />
      <path
        d="M3.14047 13.4947C3.00392 13.0745 2.5527 12.8444 2.13242 12.9811L0.552968 13.4943C0.132781 13.6308 -0.0971407 14.0821 0.0393593 14.5024C0.17614 14.9233 0.628296 15.1523 1.04741 15.016L2.6269 14.5027C3.04709 14.3663 3.27701 13.9149 3.14047 13.4947Z"
        fill="currentColor"
      />
      <path
        d="M19.7588 0.199875C19.4014 -0.0598583 18.9011 0.0193602 18.6414 0.376781L17.6846 1.69359C17.4249 2.05101 17.5041 2.55135 17.8616 2.81099C18.2191 3.07077 18.7193 2.99137 18.979 2.63409L19.9357 1.31728C20.1955 0.959858 20.1162 0.459562 19.7588 0.199875Z"
        fill="currentColor"
      />
      <path
        d="M23.447 13.4942L21.8675 12.981C21.4473 12.8442 20.996 13.0744 20.8594 13.4946C20.7229 13.9148 20.9528 14.3661 21.3731 14.5026L22.9526 15.0159C23.3719 15.1523 23.8239 14.923 23.9606 14.5023C24.0971 14.0821 23.8672 13.6308 23.447 13.4942Z"
        fill="currentColor"
      />
      <path
        d="M11.9999 19.6962C11.5581 19.6962 11.2 20.0543 11.2 20.4961V22.1198C11.2 22.5616 11.5581 22.9198 11.9999 22.9198C12.4417 22.9198 12.7999 22.5616 12.7999 22.1198V20.4961C12.7999 20.0543 12.4418 19.6962 11.9999 19.6962Z"
        fill="currentColor"
      />
    </svg>
  )
})

Star.displayName = 'Star'
